export var LogLevel;
(function (LogLevel) {
    /**All information usually needed by developers or administrators to help diagnose problems.*/
    LogLevel["DEBUG"] = "DEBUG";
    /**Something is wrong enough to compromise the correct processing of a request (for example a mandatory external resource, e.g. another HTTP server, is not responding)*/
    LogLevel["ERROR"] = "ERROR";
    /**Lowest level of traces. All service verbs at the TRACE level will dump all input and output. DO NOT enable TRACE unless you are prepared to go through a very high volume of logs. Enabling TRACE may degrade application performance.*/
    LogLevel["TRACE"] = "TRACE";
    /**Anything that can cause application misbehaviour, but that does not need human intervention.*/
    LogLevel["WARN"] = "WARN";
    /**Events meaningful for your application should go there : the creation of a user, a purchase, etc ...*/
    LogLevel["INFO"] = "INFO";
})(LogLevel || (LogLevel = {}));
export var LogSinkType;
(function (LogSinkType) {
    /**missing enum desc*/
    LogSinkType["TODO"] = "TODO";
    /**missing enum desc*/
    LogSinkType["INTERNAL"] = "INTERNAL";
    /**missing enum desc*/
    LogSinkType["REAL_TIME"] = "REAL_TIME";
})(LogSinkType || (LogSinkType = {}));
//# sourceMappingURL=LogsTypes.js.map